var map = {
	"./logo_je.svg": 4234,
	"./logo_lieferando.svg": 1158,
	"./logo_menulog.svg": 1214,
	"./logo_pl.svg": 8321,
	"./logo_skip.svg": 8340,
	"./logo_takeaway.svg": 2330,
	"./logo_thuisbezorgd.svg": 1731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1425;